import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
} from '@shared/components/games';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { HidenseekReadingControllerComponent } from './hidenseek-reading-controller/hidenseek-reading-controller.component';
import { HidenseekReadingCorrectAnswerPreviewComponent } from './hidenseek-reading-preview/hidenseek-reading-answer-preview/hidenseek-reading-answer-preview.component';
import { HidenseekReadingExamplePreviewComponent } from './hidenseek-reading-preview/hidenseek-reading-example-preview/hidenseek-reading-example-preview.component';
import { HidenseekReadingParametersPreviewComponent } from './hidenseek-reading-preview/hidenseek-reading-parameters-preview/hidenseek-reading-parameters-preview.component';
import { HidenseekReadingUserAnswerPreviewComponent } from './hidenseek-reading-preview/hidenseek-reading-user-answer-preview/hidenseek-reading-user-answer-preview.component';
import { HidenseekReadingSettingsComponent } from './hidenseek-reading-settings/hidenseek-reading-settings.component';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { FontParametersModule } from '@shared/components/games/font-parameters';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    HidenseekReadingControllerComponent,
    HidenseekReadingSettingsComponent,
    HidenseekReadingCorrectAnswerPreviewComponent,
    HidenseekReadingExamplePreviewComponent,
    HidenseekReadingParametersPreviewComponent,
    HidenseekReadingUserAnswerPreviewComponent,
  ],
  exports: [
    HidenseekReadingControllerComponent,
    HidenseekReadingSettingsComponent,
    HidenseekReadingCorrectAnswerPreviewComponent,
    HidenseekReadingExamplePreviewComponent,
    HidenseekReadingParametersPreviewComponent,
    HidenseekReadingUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FitTextModule,
    NgSelectModule,
    TextsFilterComponent,
    TextGamesSharedModule,
    FontParametersModule,
    FormFieldModule,
    MatTooltip,
  ],
})
export class HidenseekReadingModule {}
